<template lang="pug">
  .menu
    nav
      router-link(@click.native="toggleMenu", :to="{name: 'home'}") Home
      router-link(@click.native="toggleMenu", :to="{name: 'mitransicion'}") My Transition
      router-link(@click.native="toggleMenu", :to="{name: 'cienciatrans'}") Trans Science
      router-link(@click.native="toggleMenu", :to="{name: 'saludtrans'}") Trans Health
      router-link(@click.native="toggleMenu", :to="{name: 'chiletrans'}") Trans Chile
      router-link(@click.native="toggleMenu", :to="{name: 'infanciatrans'}") Trans Childhood
      router-link(@click.native="toggleMenu", :to="{name: 'avancetrans'}") Trans Progress
      a(href="/transicion/") Versión en Español

</template>
<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions([
      'toggleMenu'
    ]),
  }
}
</script>
<style lang="scss" scoped>
  .menu{
    position: fixed;
    padding-top: 65px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.8);
    z-index: 3;
    font-family: 'LaTercera', sans-serif;
    nav{
      margin: 0;
      padding: 0;
      a{
        display: block;
        padding: 1rem;
        font-size: 1.4rem;
        text-transform: uppercase;
        color: #30a3e5;
        &:hover{
          background-color: #e9008b;
          color: white;
        }
      }
    }
  }
</style>



